<template>
  <input class="c-form__input"
         :type="type"
         :name="name"
         :placeholder="placeholder"
         :min="min"
         :max="max"
         :value="value"
         :disabled="disabled"
         v-bind:auto-focus="autoFocus"
         :maxlength="maxLength"
         :class="{'border-red-600 border': hasError}"
         @input="$emit('input',$event.target.value)"/>
</template>
<script>
export default {
  name: "Input",

  description: "Input to be used for text, email and number fields",

  props: {
    type: {type: String, default: "text", note: "This can be: email, number or text"},
    name: {
      type: String,
      default: null,
      required: true,
      note: "Define a name that's been used in the default_json of an document"
    },
    idkey: {
      type: Number,
      default: null,
      required: true,
      note: "This is an unique id for adding an id prop to html"
    },
    placeholder: {type: String, default: null},
    min: {type: Number, default: null},
    max: {type: Number, default: null},
    required: {type: Boolean, default: false},
    value: {
      default: null,
      note: "This is the value that's currently set in this field. Via v-model the value will be automaticly updated"
    },
    disabled: {type: Boolean, default: false},
    autoFocus: {type: Boolean, default: false},
    maxLength: {required: false, type: Number, default: 255},
    hasError: {required: false, default: false}
  },
}
</script>
